import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { useDimensions } from '@24i/nxg-sdk-quantum';
import { Header, HeaderContainer } from '../../../components';
import { Metadata } from '../../../../Metadata';
import { BackButtonContainer } from './styled';
import { BackButton } from './components';
export const PlayerHeader = ({ onBack, asset, seriesData, isSeeking, currentProgram, blockingReason, shouldShowAirtime = false, }) => {
    var _a;
    const { theme } = useTheme();
    const TelegramWebApp = getTelegramWebApp();
    const { isLandscape } = useDimensions();
    return (React.createElement(Header, { isSeeking: isSeeking, gradient: (_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.gradient3 },
        React.createElement(HeaderContainer, { isFullscreen: TelegramWebApp === null || TelegramWebApp === void 0 ? void 0 : TelegramWebApp.isFullscreen, isLandscape: isLandscape },
            onBack && (React.createElement(BackButtonContainer, { theme },
                React.createElement(BackButton, { onBack }))),
            React.createElement(Metadata, { asset: Object.assign(Object.assign({}, asset), currentProgram), blockingReason, seriesData, shouldShowAirtime }))));
};
//# sourceMappingURL=index.js.map